import PurchaseMethodsActionsV25 from 'commons-vehicle/PurchaseMethodsV25/actions/purchaseMethodsActionsV25.js';
import PurchaseMethodsActionsTypesV25 from 'commons-vehicle/PurchaseMethodsV25/actions/purchaseMethodsActionTypesV25.js';
import PaymentFrequencies from 'commons-vehicle/PurchaseMethodsV25/constants/paymentFrequencies.js';
import PurchaseMethodsConstantV25 from 'commons-vehicle/PurchaseMethodsV25/constants/purchaseMethodsV25.js';
import PurchaseMethodsValuesV25 from 'commons-vehicle/PurchaseMethodsV25/constants/purchaseMethodsValuesV25.js';
import ApiFetchStatusConstant from 'commons-vehicle/PurchaseMethodsV25/constants/apiFetchStatus.js';
import en from 'commons-vehicle/PurchaseMethodsV25/i18n/en.json';
import fr from 'commons-vehicle/PurchaseMethodsV25/i18n/fr.json';
import PurchaseMethodsModelV25 from 'commons-vehicle/PurchaseMethodsV25/models/PurchaseMethodsModelV25.js';
import CashPurchaseModelV25 from 'commons-vehicle/PurchaseMethodsV25/models/CashPurchaseModelV25.js';
import BestIncentivesModelV25 from 'commons-vehicle/PurchaseMethodsV25/models/BestIncentivesModelV25.js';
import PurchaseMethodsReducerV25 from 'commons-vehicle/PurchaseMethodsV25/reducers/purchaseMethodsReducerV25.js';
import PurchaseMethodsService from 'commons-vehicle/PurchaseMethodsV25/services/PurchaseMethodsService/PurchaseMethodsServiceV25.js';
import AmountLineItem from 'commons-vehicle/PurchaseMethodsV25/components/AmountLineItem/AmountLineItem.jsx';
import DisclaimerAPIService from 'commons-vehicle/PurchaseMethods/services/PurchaseMethodsAPIService/DisclaimerAPIService.js';

const Translations = {
    en,
    fr,
};

export {
    PurchaseMethodsActionsV25,
    PurchaseMethodsActionsTypesV25,
    PaymentFrequencies,
    PurchaseMethodsConstantV25,
    PurchaseMethodsValuesV25,
    Translations,
    PurchaseMethodsModelV25,
    CashPurchaseModelV25, // v2.5 new pricing API model
    BestIncentivesModelV25, // v2.5 new pricing API model
    PurchaseMethodsReducerV25,
    PurchaseMethodsService,
    DisclaimerAPIService,
    AmountLineItem,
    ApiFetchStatusConstant,
};

export default {
    PurchaseMethodsActionsV25,
    PurchaseMethodsActionsTypesV25,
    PaymentFrequencies,
    PurchaseMethodsConstantV25,
    PurchaseMethodsValuesV25,
    Translations,
    PurchaseMethodsModelV25,
    CashPurchaseModelV25,
    BestIncentivesModelV25,
    PurchaseMethodsReducerV25,
    PurchaseMethodsService,
    DisclaimerAPIService,
    AmountLineItem,
    ApiFetchStatusConstant,
};
